import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { signinSilentCallback } from '../../services/authService';
import EpPageLoading from '../../components/EpPageLoading';

function SilentRefreshPage() {
  const history = useHistory();

  useEffect(() => {
    async function silentRefreshAsync() {
      await signinSilentCallback();
      history.push('/');
    }
    silentRefreshAsync();
  }, [history]);

  return <EpPageLoading />;
}

export default SilentRefreshPage;
